import { FC } from 'react';

import { INode } from 'react-accessible-treeview';

import { AppRoutes } from 'constants/routes-paths.constants';
import { ColumnDefaultControls } from 'shared-components/table/ColumnDefaultControls';
import { TableData } from 'shared-components/table/TableData';
import { TableRow } from 'shared-components/table/TableRow';
import { getCommonRoutes } from 'utils/routes.utils';

interface Props {
  handleDelete: VoidFunction;
  parent?: INode;
  data: INode;
}

export const InconsistencyTypesTableRow: FC<Props> = ({ handleDelete, data: { id, name } }) => {
  const { editRoute, viewRoute } = getCommonRoutes(AppRoutes.inconsistencyTypes, +id);

  return (
    <TableRow>
      <TableData className='w-fit'>
        <ColumnDefaultControls
          handleDelete={handleDelete}
          editRoute={editRoute}
          viewRoute={viewRoute}
          editPermission='inconsistencyTypes.update'
          deletePermission='inconsistencyTypes.delete'
          viewPermission='inconsistencyTypes.view'
        />
      </TableData>
      <TableData>{id}</TableData>
      <TableData className='last:text-left'>{name}</TableData>
    </TableRow>
  );
};
